// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"670":"73306872","937":"73306872"}[chunkId] + ".chunk.css";
};